<template>
  <div
    ref="target"
    :class="['live-commentary-menu',{'live-commentary-menu-input': inputShow}]"
    tabindex="0"
    @click.stop
  >
    <div class="live-commentary-menu-wrap">
      <div class="live-commentary-menu-top">
        <BubbleBall v-show="!inputShow" />

        <CommentaryInput
          ref="commentaryInput"
          :input-show="inputShow"
          :comment-input="commentInput"
          @changeInputShow="changeInputShow"
          @changeInput="changeInput"
        />

        <VButton
          v-show="inputShow"
          :disabled="inputDisabled"
          :loading="buttonLoading"
          class="live-commentary-menu-post"
          @click="handlePost"
        >
          <span v-if="!buttonLoading">
            {{ quoteData ? 'Reply' : 'Post' }}
          </span>
        </VButton>

        <div
          v-show="!inputShow"
          class="live-commentary-menu-chat-wrap"
        >
          <div
            class="live-commentary-menu-chat"
            :class="{
              'live-commentary-menu-chat-disabled': commentsDisabled,
              'is-act':commentShow
            }"
            @click="judgeCommentsStatus"
          >
            <svg-icon icon-class="icon-message" />
          </div>
          <span
            v-show="!commentsDisabled && showCommensNum"
            class="live-commentary-menu-chat-count"
          >
            {{ showCommensNum }}
          </span>
        </div>
        <template v-if="hasSetting">
          <div
            v-show="!inputShow"
            :class="['live-commentary-menu-setting',{'is-act':settingShow}]"
            @click="handleSetting()"
          >
            <svg-icon
              icon-class="icon-setting"
            />
          </div>
        </template>
      </div>
      <div
        v-show="inputShow"
        class="live-commentary-menu-error"
      >
        <div class="text">
          {{ inputErrorText }}
        </div>
        <div :class="{'noError': !inputErrorText}">
          {{ commentInput.length }} / {{ maxInput }}
        </div>
      </div>
    </div>

    <template v-if="hasSetting">
      <transition name="slide-up">
        <CommentarySetting
          v-if="settingShow"
          @close="handleSetting()"
        />
      </transition>
    </template>

    <transition name="slide-up">
      <CommentPanel
        v-if="commentShow"
        ref="commentPanel"
        @close="closeComment"
        @openCode="openCode"
      />
    </transition>

    <VDialogBox
      v-model="contentAttentionShow"
      title="Attention !"
      :show-close="false"
      :show-footer="true"
      confirm-button-text="OK"
      cancel-button-text="Check Rules"
      :close-on-click-modal="false"
      @update-action="actionCommentsRules"
    >
      <div class="dialog--body">
        <p class="dialog-content">
          Certain contents you entered violates the rules and not allowed to be published. Multiple times of violation may invovle the risk of account blocking. Please be care with the content and follow the rules of platform.
        </p>
        <div class="dialog-content contain-item">
          <p
            v-for="(item, key) in attentionList"
            :key="key"
            :class="{'alert': key === curAlert}"
          >
            --{{ item }}
          </p>
        </div>
      </div>
    </VDialogBox>

    <!-- code item -->
    <BookingcodeDetail
      :code="currentCode"
      @submit="onAddToBetslip"
      @close="closeCodeDetail"
    />
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { getCurrentInstance, ref } from '@vue/composition-api'
import { onClickOutside } from '@vueuse/core'
import { useAuthStore } from '@ms/stores/auth'
import { useUserStore } from '@ms/stores/user'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { useCommentsStore } from 'wap/stores/comments'
import { useWapBetslipStore } from 'wap/stores/betslip'
import { COMMENTS_NOT_AVAILABLE } from '@ms/config/message'
import eventBus from '@ms/utils/event-bus.js'
import BookingcodeDetail from 'wap/components/BookingCode'
import CommentarySetting from './CommentarySetting.vue'
import CommentaryInput from './CommentaryInput.vue'
import CommentPanel from './CommentPanel.vue'
import VButton from 'fe-vui/button'
import VDialogBox from 'fe-vui/dialogBox'
import toast from 'fe-vui/toast'
import modalHelper from '@ms/utils/scroll-fixed'
import BubbleBall from './BubbleBall'
import 'base/icons/svg/setting.svg'
import 'base/icons/svg/message.svg'

export default {
  name: 'CommentaryMenu',
  components: {
    VButton,
    VDialogBox,
    CommentarySetting,
    CommentaryInput,
    CommentPanel,
    BubbleBall,
    BookingcodeDetail
  },
  props: {
    // 是否显示 setting 按钮
    hasSetting: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const { proxy: vm } = getCurrentInstance()
    const auth = useAuthStore()
    const { loginStatus } = storeToRefs(auth)
    const user = useUserStore()
    const { showNickname } = storeToRefs(user)
    const commentsStore = useCommentsStore()
    const { totalCount, quoteData, commentsDisabled } = storeToRefs(commentsStore)

    const target = ref(null)
    onClickOutside(target, () => {
      vm.onBlur()
    })

    const { getCommentsStatus, getUserCommentsAuthority, publishComments, getComments, updateQuoteData } = commentsStore

    const matchDetailStore = useMatchDetailStore()
    const { event } = storeToRefs(matchDetailStore)

    return {
      target,
      loginStatus,
      showNickname,
      totalCount,
      quoteData,
      commentsDisabled,
      getCommentsStatus,
      getUserCommentsAuthority,
      publishComments,
      getComments,
      updateQuoteData,
      event
    }
  },
  data() {
    return {
      settingShow: false,
      inputShow: false,
      commentShow: false,
      buttonLoading: false,
      contentAttentionShow: false, // 发表的评论违法提示框
      curAlert: 0,
      attentionList: ['May contain advertisements.', 'May contain improper words.', 'May contain personal information (such as mobile phone number)'],
      commentInput: '',
      inputErrorText: '',
      maxInput: 255,
      currentCode: ''
    }
  },
  computed: {
    showCommensNum() {
      return this.totalCount > 99 ? '99+' : this.totalCount
    },
    inputDisabled() {
      return !this.commentInput || this.commentInput.length > this.maxInput
    }
  },
  watch: {
    settingShow(val) {
      eventBus.$emit('commentary-betslip-ball', val)
    },
    commentShow(val) {
      eventBus.$emit('commentary-betslip-ball', val)
    },
    loginStatus(val) {
      if (val) {
        this.initFetch()
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.closeInput)
  },
  created() {
    if (this.loginStatus) {
      this.initFetch()
    }
    const { sportId, eventId } = this.event
    this.getCommentsStatus({ sportId, eventId })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeInput)
    useCommentsStore().$reset()
  },
  methods: {
    initFetch() {
      this.getUserCommentsAuthority() // 获取用户评论权限
      useUserStore().getAccountInfoWrap() // 获取用户nickname
    },
    // async fetchGetComments () {
    //   try {
    //     const params = {
    //       eventId: this.event.eventId,
    //       eventStatus: this.event.status,
    //       lastCommentsId: ''
    //     }
    //     await this.getComments(params)
    //   } catch (e) {
    //     // 不抛出错误 该接口只刷新总条数 错误不影响
    //     console.error(e)
    //   }
    // },
    async fetchPublishComments() {
      this.buttonLoading = true
      try {
        const nickName = this.showNickname
        const params = {
          comments: this.commentInput,
          sportId: this.event.sportId,
          eventId: this.event.eventId,
          eventStatus: this.event.status,
          nickName
        }
        if (this.quoteData) params.pid = this.quoteData.id
        const { bizCode, message = '' } = await this.publishComments(params)
        // 需要判断状态码
        if (bizCode === 10000) {
          // 成功
          // data中status不区分
          toast('Post successful !')
          this.commentInput = ''
          this.inputShow = false
          this.$refs.commentPanel && this.$refs.commentPanel.handleScrollTop()
          // this.fetchGetComments() // 刷新总条数
          // 如果有引用评论则清空
          if (this.quoteData) this.updateQuoteData(null)
        } else if (bizCode === 4210) {
          // 发布的时候用户状态如被封禁
          this.$dialog({
            title: 'Note',
            message,
            confirmButtonText: 'OK',
            cancelButtonText: 'Check Rules'
          })
            .catch(() => {
              this.$refs.commentaryInput.openCommentsRules()
            })
        } else if (bizCode === 4230) {
          // 包含违规内容，不允许发布,文案在前端已写好
          this.curAlert = Number(message) - 1
          this.contentAttentionShow = true
        } else {
          // 4220 发布的时候评论功能关闭
          // 其余异常状态也弹窗提醒
          this.$dialog({
            title: 'Note',
            message,
            confirmButtonText: 'OK',
            cancelButtonText: null
          }).catch(console.log)
        }
        this.buttonLoading = false
      } catch (e) {
        console.error(e)
        this.buttonLoading = -1
      }
    },
    handleSetting() {
      this.settingShow = !this.settingShow
      if (this.settingShow) {
        this.$el.focus()
      }
      if (this.commentShow) {
        this.closeComment()
      }
    },
    onBlur() {
      modalHelper.beforeClose()
      this.settingShow = false
      this.commentShow = false
    },
    judgeCommentsStatus() {
      if (this.commentsDisabled) {
        toast(COMMENTS_NOT_AVAILABLE)
      } else if (this.commentShow) {
        this.closeComment()
      } else {
        this.settingShow = false
        this.commentShow = true
        modalHelper.afterOpen()
      }
    },
    changeInputShow(bool) {
      this.inputShow = bool
    },
    changeInput(val) {
      if (val && val.length > this.maxInput) {
        this.inputErrorText = 'The content exceeds the maximum limit, please delete and try again.'
        this.commentInput = val
      } else {
        this.inputErrorText = ''
        this.commentInput = val
      }
    },
    handlePost() {
      // fetch
      if (!this.commentInput) {
        return false
      } else if (this.commentInput.length > this.maxInput) {
        this.inputErrorText = 'The content exceeds the maximum limit, please delete and try again.'
      } else {
        this.fetchPublishComments()
      }
    },
    closeComment() {
      modalHelper.beforeClose()
      this.commentShow = false
    },
    actionCommentsRules(e) {
      if (e === 'cancel') {
        this.contentAttentionShow = false
        this.$refs.commentaryInput.openCommentsRules()
      } else {
        this.contentAttentionShow = false
      }
    },
    closeInput() {
      this.inputShow = false
    },
    onAddToBetslip() {
      const wapBetslipStore = useWapBetslipStore()
      wapBetslipStore.updateFromLocalSelections()
      wapBetslipStore.subBetslip()
      this.closeCodeDetail()
    },
    openCode(code) {
      this.currentCode = code
    },
    closeCodeDetail() {
      this.currentCode = ''
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-menu {
  position: fixed;
  z-index: 1010;   // 高于角标广告角位
  bottom: 0;
  width: 100%;
  max-width: 750px;
  height: 60px;
  background: @major;
  outline: none;

  &-wrap {
    position: relative;
    z-index: 20;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    background: @major;
    box-shadow: 0 -4px 20px 0 rgba(0, 0, 0, 50%);
  }

  &-top {
    position: relative;
    z-index: 20;
    display: flex;
    width: 330/360 * 100%;
    height: 100%;
    align-items: center;
    justify-content: space-evenly;
    margin: 0 auto;

    & .v-button .icon-loading {
      width: 20px;
      height: 20px;
      margin-right: 0;
    }
  }

  &-error {
    display: flex;
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    padding: 5px 0 0 30px;
    color: #ff3826;
    font-size: 10px;
    line-height: 11px;

    & .text {
      width: 177/330 * 100%;
      height: 30px;
      margin-right: 4px;
      background: @major;
    }

    & .noError {
      width: 50/330 * 100%;
      color: @gray;
      text-align: right;
    }
  }

  &-input-warp {
    position: relative;
    flex: 1;

    .menu-input {
      width: 100%;
      color: @gray;
      text-align: center;

      & .v-input-wrap,
      .v-input,
      input {
        width: 100%;
        height: 32px;
        background-color: @white;
        caret-color: @major;
        font-size: 12px;
      }

      & input::input-placeholder {
        color: @gray;
      }

      .v-input-wrap {
        padding: 0 15px;
      }

      .v-input-wrap.focus {
        border: 1px solid transparent;
      }

      .v-input--inner {
        overflow: hidden;
        padding: 0;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      & .v-input--append {
        position: relative;
        left: 4px;
        height: auto;
      }

      &.has-quote {
        border: 1px solid transparent;
        border-radius: 12px;
        background: #fff;

        .v-input-wrap {
          border: none;
        }

        .menu-input-quote {
          position: relative;
          width: 94%;
          box-sizing: border-box;
          padding: 4px 24px 4px 12px;
          border-radius: 8px;
          margin: 8px auto 0;
          background: #f2f2f2;
          color: #666;
          font-size: 12px;
          line-height: 14px;
          text-align: left;

          &::before {
            position: absolute;
            top: 50%;
            left: 1px;
            width: 2px;
            height: 80%;
            border-radius: 30px 0 0 30px;
            background: #ffca27;
            content: "";
            transform: translateY(-50%);
          }

          .icon-clear {
            position: absolute;
            top: 50%;
            right: 6px;
            color: #999;
            cursor: pointer;
            font-size: 14px;
            transform: translateY(-50%);

            &:hover {
              color: #666;
            }
          }

          & > p {
            word-break: break-all;
            .mutiple-ellipsis(2);
          }
        }
      }
    }

    & .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-left: 15px;
      border-radius: 16px;
      background: transparent;
      color: @gray;
      font-size: 10px;
      line-height: 32px;
    }

    .overlay-disabled {
      overflow: hidden;
      background-color: @disabled;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &-post {
    width: 56px;
    height: 32px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: @primary;
    font-size: 14px;
    line-height: 32px;
    text-align: center;

    &:active {
      background-color: #b28d1b;
    }
  }

  &-chat-wrap {
    position: relative;
    width: 32px;
    height: 32px;
    margin-left: 10px;
  }

  &-chat-count {
    position: absolute;
    top: -5px;
    right: -8px;
    height: 14px;
    padding: 0 5px;
    border-radius: 14px;
    background-color: #666;
    color: @primary;
    font-size: 9px;
    line-height: 14px;
  }

  &-setting {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
  }

  &-chat {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-chat,
  &-setting {
    width: 32px;
    height: 32px;
    box-sizing: border-box;
    border: 1px solid @primary;
    border-radius: 32px;
    background-color: @primary;

    .svg-icon {
      color: @dark;
    }

    &.is-act {
      background-color: @major;

      .svg-icon {
        color: @primary;
      }
    }
  }

  &-chat-disabled {
    border: 1px solid @disabled;
    background-color: @disabled;

    .svg-icon {
      color: @gray;
    }
  }

  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .slide-up-enter,
  .slide-up-leave-to {
    opacity: 0;
    transform: translateY(100%);
  }

  & .dialog .contain-item {
    line-height: 20px;

    & .alert {
      color: #ff3826;
    }
  }

  & .dialog .dialog-content {
    margin-bottom: 10px;
  }
}

.live-commentary-menu-input {
  height: auto;

  & .live-commentary-menu-input-warp {
    width: 254/330 * 100%;
    flex: none;
  }

  .live-commentary-menu-top {
    align-items: flex-end;
    justify-content: space-between;
    padding-top: 20px;
  }
}
</style>
